const state = {
    inspectTimeoutDetailDataFields: [
        {
            key: "device_name",
            label: "機台",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight",
            rowspan: true
        },
        {
            key: "batch_qty",
            label: "批數小計",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight",
            rowspan: true
        },
        {
            key: "inspect_qty",
            label: "檢驗筆數小計",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight",
            rowspan: true
        },
        {
            key: "timeout_qty",
            label: "超時筆數小計",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight",
            rowspan: true
        },
        {
            key: "batch",
            label: "批號",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "last_time",
            label: "前次檢驗時間",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "this_time",
            label: "當次檢驗時間",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "interval_time",
            label: "間隔時間",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        }
    ],
    inspectTimeoutDetailDataItem: [],
    inspectFactory:""
};
const getters = {
    get_inspectTimeoutDetailDataFields: state => {
        return state.inspectTimeoutDetailDataFields;
    },
    get_inspectTimeoutDetailDataItem: state => {
        return state.inspectTimeoutDetailDataItem;
    },
    get_inspectFactory: state => {
        return state.inspectFactory;
    }
};
const actions = {
    set_inspectTimeoutDetailDataFields(context, array) {
        context.commit("SET_INSPECTTIMEOUTDETAILDATAFIELDS", array);
    },
    set_inspectTimeoutDetailDataItem(context, array) {
        context.commit("SET_INSPECTTIMEOUTDETAILDATAITEM", array);
    },
    clear_inspectTimeoutDetailDataItem(context) {
        context.commit("CLEAR_INSPECTTIMEOUTDETAILDATAITEM");
    },
    set_inspectFactory(context, string) {
        context.commit("SET_INSPECTFACTORY", string);
    }
};
const mutations = {
    SET_INSPECTTIMEOUTDETAILDATAFIELDS(state, array) {
        state.inspectTimeoutDetailDataFields = array;
    },
    SET_INSPECTTIMEOUTDETAILDATAITEM(state, array) {
        state.inspectTimeoutDetailDataItem = array;
    },
    CLEAR_INSPECTTIMEOUTDETAILDATAITEM(state) {
        state.inspectTimeoutDetailDataItem = [];
    },
    SET_INSPECTFACTORY(state, string) {
        state.inspectFactory = string;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/inspectTimeoutDetailData.js